import ActionRow from './ActionRow'

function ActionButtonRow({
  Icon,
  label,
  trailingIcon,
  onClick,
  compact = false,
  plain = false,
  active = false,
  iconOnly = false,
  buttonProps,
}) {
  return (
    <ActionRow
      Icon={Icon}
      label={label}
      trailingIcon={trailingIcon}
      onClick={onClick}
      compact={compact}
      plain={plain}
      active={active}
      iconOnly={iconOnly}
      buttonProps={buttonProps}
    />
  )
}

export default ActionButtonRow
